import axios from 'axios'
import config from '../config/dev.json'
import production from '../config/production.json'

const path = '/api/contact'
let url

if (process.env.NODE_ENV === 'production') url = production.host + path
else url = config.host + path

url = 'http://102.219.178.151/backend/api/bannerBoost'

export function GetAllBannerBoosts() {
  return new Promise((resolve, reject) => {
    axios.get(url).then(response => {
      resolve(response.data)
    }).catch(err => resolve("echeck"))
  })
}

export function AddBannerBoostService(bannerBoost) {
    return new Promise((resolve, reject) => {
        axios.post(url, bannerBoost).then(response => {
            resolve(response)
        }).catch(err => resolve("echeck"))
    }) 
}

export function UpdateBannerBoostService(bannerBoost) {
    return new Promise((resolve, reject) => {
        axios.put(url + '/' +bannerBoost._id, bannerBoost).then(response => {
            resolve(response.data)
        }).catch(err => reject(err))
    }) 
}

export function DeleteBannerBoostService(bannerBoost) {
    return new Promise((resolve, reject) => {
        axios.delete(url + '/'+ bannerBoost._id).then(response => {
            resolve(response)
        }).catch(err => reject(err))
    }) 
}


